import React from 'react'
import PropertiesProvider from 'modules/properties/PropertiesProvider'
import { ContactsProvider } from 'modules/contacts'
import { SearchFilterProvider } from '../../../../views/providers'
import EditProperty from './EditProperty'

const EditPropertyRoute = (props: any) => (
  <PropertiesProvider {...props}>
    <ContactsProvider {...props}>
      <SearchFilterProvider location={props.location}>
        <EditProperty />
      </SearchFilterProvider>
    </ContactsProvider>
  </PropertiesProvider>
)

export default EditPropertyRoute
